import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TimePicker from 'material-ui/TimePicker';
import moment from "moment-timezone";
import i18next from 'i18next';

function getDateFromSeconds(seconds) {  
  const date = new Date();
  const hours = Math.round(seconds/60/60);
  const minutes = Math.round((seconds - (hours * 60 * 60))/60);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0, 0);
}

function getSecondsFromDate(date) {
  return Math.round((date.getHours() * 60 * 60) + (date.getMinutes() * 60));
}

function getDateTimeFromTime(time) {
  return getDateFromSeconds(getSecondsFromDate(moment(time, 'HH:mm').toDate()));
}

function getTimeFromDateTime(dt) {
  return moment(dt).format('HH:mm');
}

const TimePickerInput = ({ input, label, type, textarea, valueType, meta: { touched, error, warning, invalid }, isDisabled }) => {
  const timeFormat = moment.localeData(i18next.language).longDateFormat('LT').includes('HH') ? '24hr' : 'ampm';
  return input.value === '' ? null : (
      <div className={"form-group " + (touched && error  ? 'has-error' : '')} >
        <label>{label}</label>
        { isDisabled ?
          <div>
            <div className='form-control'>
              {moment(valueType === 'milliseconds' ? getDateFromSeconds(input.value) : getDateTimeFromTime(input.value)).format(timeFormat == '24hr' ? 'HH:mm' : 'h:mm a')}
            </div>
          </div> :
          <div>
            <MuiThemeProvider>
              <TimePicker
                  {...input}
                  cancelLabel={ i18next.t('form-labels.cancel') }
                  okLabel={ i18next.t('form-labels.ok') }
                  value = {null}
                  defaultTime = {valueType === 'milliseconds' ? getDateFromSeconds(input.value) : getDateTimeFromTime(input.value)}
                  onChange = { (_, value) => {input.onChange(valueType === 'milliseconds' ? getSecondsFromDate(value) : getTimeFromDateTime(value))} }
                  format = {timeFormat}
                  placeholder={label}
                  className={`form-control ${touched && invalid ? 'has-danger' : ''}`}
                  underlineStyle={{
                    display: 'none'
                  }}
                  textFieldStyle={{
                    display: 'block',
                    width: '100%',
                    height: '44px',
                    padding: '10px 15px',
                    fontSize: '16px',
                    lineHeight: '1.42857',
                    color: '#555555',
                    backgroundColor: '#fff',
                    backgroundImage: 'none',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    WebkitBoxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
                    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075)',
                    WebkitTransition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s',
                    OperaTransition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s',
                    transition: 'border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s'
                  }}
              />
            </MuiThemeProvider>
            {touched && ((error && <span className="input-error">{error}</span>) || (warning && <span className="input-warning">{warning}</span>))}
          </div>
        }
      </div>
  );
};

export default TimePickerInput;
